const initBlogLoadMore = () => {
  const sectionEl = document.querySelector('[data-blog-section]');
  if (!sectionEl || sectionEl.dataset.loadMoreInit) return;
  sectionEl.dataset.loadMoreInit = 'true';

  const gridEl = sectionEl.querySelector('[data-article-grid]');
  const countEl = sectionEl.querySelector('[data-article-count]');
  const loadMoreEl = sectionEl.querySelector('[data-load-more]');
  if (!gridEl || !loadMoreEl) return;

  let isLoading = false;

  const loadNextPage = async (event) => {
    event.preventDefault();

    const nextUrl = loadMoreEl.dataset.nextUrl;
    if (isLoading || !nextUrl) return;

    isLoading = true;
    loadMoreEl.setAttribute('aria-disabled', 'true');

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionEl.dataset.sectionId);

      const response = await fetch(url);
      if (!response.ok) throw new Error(`Loading more articles failed with status ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const nextGridEl = doc.querySelector('[data-article-grid]');
      if (!nextGridEl) throw new Error('Loading more articles returned an unexpected response');

      const cardEls = nextGridEl.querySelectorAll(':scope > *');
      cardEls.forEach(cardEl => gridEl.appendChild(cardEl));

      const nextCountEl = doc.querySelector('[data-article-count]');
      if (countEl && nextCountEl) countEl.innerHTML = nextCountEl.innerHTML;

      const nextLoadMoreEl = doc.querySelector('[data-load-more]');
      if (nextLoadMoreEl) {
        loadMoreEl.dataset.nextUrl = nextLoadMoreEl.dataset.nextUrl;
        loadMoreEl.href = nextLoadMoreEl.dataset.nextUrl;
      } else {
        if (countEl) {
          countEl.setAttribute('tabindex', '-1');
          countEl.focus();
        }
        loadMoreEl.hidden = true;
        loadMoreEl.removeEventListener('click', loadNextPage);
      }
    } catch (error) {
      console.error(error);
    } finally {
      isLoading = false;
      loadMoreEl.removeAttribute('aria-disabled');
    }
  };

  loadMoreEl.addEventListener('click', loadNextPage);
};

export default initBlogLoadMore;
